import FindLocationResultState from '../data/schema/FindLocationResultState';
import { action } from 'satcheljs/lib/legacy';
import { LocationPersonaControlViewState } from 'owa-location-persona';

/**
 * Clears and updates the findresults set and shows the find result dropdown
 * @param findLocationResultState: the location well holding the find location control
 * @param locationsToAdd: the locations results to add
 */
export default action('updateFindResult')(function updateFindResult(
    findLocationResultState: FindLocationResultState,
    locationsToAdd: LocationPersonaControlViewState[]
) {
    if (!findLocationResultState.findResultSet) {
        findLocationResultState.findResultSet = [];
    }

    // if locationsToAdd is null the splice in the next line will add an entry to findResultSet whose value is null
    // the desired behaviour if to keep the array empty if locationsToAdd is null, so we initalize it to an empty array
    if (!locationsToAdd) {
        locationsToAdd = [];
    }

    // clear find array and fill it with locationsToAdd
    findLocationResultState.findResultSet.splice(
        0,
        findLocationResultState.findResultSet.length,
        ...locationsToAdd
    );
});
